var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0995 15.9542C33.8206 14.8773 33.0032 14.0284 31.9666 13.7384C30.0729 13.2002 22.4978 13.2002 22.4978 13.2002C22.4978 13.2002 14.923 13.2002 13.0293 13.718C12.0126 14.0077 11.1753 14.8774 10.8964 15.9542C10.3981 17.9211 10.3981 22.0002 10.3981 22.0002C10.3981 22.0002 10.3981 26.0999 10.8964 28.0462C11.1756 29.123 11.9927 29.9719 13.0294 30.2618C14.943 30.8002 22.4981 30.8002 22.4981 30.8002C22.4981 30.8002 30.0729 30.8002 31.9666 30.2824C33.0033 29.9926 33.8206 29.1437 34.0998 28.0669C34.598 26.0999 34.598 22.0209 34.598 22.0209C34.598 22.0209 34.6179 17.9211 34.0995 15.9542ZM20.0861 25.7686V18.2318L26.3851 22.0002L20.0861 25.7686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.5e972dc4ad8a32a561223c525bd35970.svg";
export { ForwardRef as ReactComponent };